import { addClass } from '~/js/utils/class-management';
import {
  getArrayFromNodeList,
  getDiv,
  getNodeList,
} from '~/js/utils/selectors';

const makeEmptyMessage = () => {
  const emptyDiv = document.createElement('div');
  addClass(emptyDiv, 'table-empty-message');
  emptyDiv.innerText = 'Nenhum item encontrado com o filtro ativo.';

  return emptyDiv;
};

const emptyMessage = makeEmptyMessage();

function showEmptyMessage(table: HTMLTableElement) {
  const alreadyAppended = getDiv('.table-empty-message', table?.parentElement);
  if (!alreadyAppended) {
    table.insertAdjacentElement('afterend', emptyMessage);
  }
}

function removeEmptyMessage(table: HTMLTableElement) {
  const alreadyAppended = getDiv('.table-empty-message', table?.parentElement);
  if (alreadyAppended) {
    alreadyAppended.remove();
  }
}

function isHidden(el: Element) {
  const style = window.getComputedStyle(el);
  return style.display === 'none' || style.visibility === 'hidden';
}

function getVisibleComponents<T extends Element>(items: T[]) {
  return items.filter((item) => !isHidden(item));
}

function hidePagination(table: HTMLTableElement) {
  const pagination = getDiv('.table-pagination', table.parentElement);
  if (pagination) {
    pagination.style.opacity = '0';
  }
}

function showPagination(table: HTMLTableElement) {
  const pagination = getDiv('.table-pagination', table.parentElement);
  if (pagination) {
    pagination.style.opacity = '1';
  }
}

function runFilter(
  value: string,
  table: HTMLTableElement,
  pagination?: number
) {
  const rows = getNodeList<HTMLTableRowElement>('tbody tr', table);
  const rowsAsArray = getArrayFromNodeList(rows);
  const lower = value.toLowerCase();

  if (value === '') {
    showPagination(table);
    rowsAsArray.forEach((row, index) => {
      row.style.display =
        pagination && index < pagination ? 'table-row' : 'none';
    });
  } else {
    hidePagination(table);
    rows.forEach((row) => {
      if (row.innerText.toLowerCase().includes(lower)) {
        return (row.style.display = 'table-row');
      }
      row.style.display = 'none';
    });
  }

  const visible = getVisibleComponents(rowsAsArray).length;
  if (visible === 0) return showEmptyMessage(table);
  removeEmptyMessage(table);
}

function filterTableResult(table: HTMLTableElement, pagination?: number) {
  const inputWrap = document.createElement('div');
  addClass(inputWrap, 'input-field');
  const input = document.createElement('input');
  input.setAttribute('type', 'text');
  input.setAttribute('placeholder', 'Filtre os resultados');
  input.setAttribute('aria-label', 'Filtre os resultados da tabela');
  addClass(input, 'table-filter-result');

  input.addEventListener('keyup', (e) => {
    runFilter((e.currentTarget as HTMLInputElement).value, table, pagination);
  });

  const tableHeadWrap = table.parentElement?.querySelector(
    '.table-head-wrap'
  ) as HTMLDivElement;

  inputWrap.insertAdjacentElement('beforeend', input);

  tableHeadWrap.insertAdjacentElement('beforeend', inputWrap);
}

export default filterTableResult;
